import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import menus from '../../config/menuConfig';
import './index.sass'

import {Menu} from 'antd';

class NavLeft extends Component {
    constructor (props) {
        super(props);
        this.state = {
            selectedKeys: [],
            openKeys: []
        }
    }

    componentDidMount () {
        const pathname = this.props.location.pathname.split('?')[0];
        const menuKeys = pathname.split("/").slice(0, 3).join('/');
        this.selectMenu({
            key: pathname,
            keyPath: menuKeys
        });
    }

    selectMenu = (item) => {
        // 选中菜单
        const menuHigh = {
            selectedKeys: item.key,
            openKeys: item.keyPath[item.keyPath.length - 1]
        }
        this.selectMenuHigh(menuHigh);
    }

    openMenu = (openKeys) => {
        // 展开
        this.setState({
            openKeys: [openKeys[openKeys.length - 1]]
        });
    }


    selectMenuHigh = ({selectedKeys, openKeys}) => {
        // 菜单高亮
        this.setState({
            selectedKeys: [selectedKeys],
            openKeys: [selectedKeys.split('/')[1], openKeys]
        })
    }

    render () {
        const {selectedKeys, openKeys} = this.state
        return (
            <div>
                <Menu
                    onOpenChange={this.openMenu}
                    onClick={this.selectMenu}
                    theme="dark"
                    mode="inline"
                    selectedKeys={selectedKeys}
                    openKeys={openKeys}
                    items={menus}
                >
                </Menu>
            </div>
        )
    }
}

export default withRouter(NavLeft)
